if (!customElements.get("cart-upsell")) {
  customElements.define(
    "cart-upsell",
    class CartUpsell extends HTMLElement {
      constructor() {
        super();
        this.el = this;
        this.updateURL = this.dataset.url;
        this.similarActive = this.dataset.cartCount == "true";
      }

      connectedCallback() {
        this.cartCount = parseInt(this.dataset.cartCount);
        if (this.cartCount == 0) {
          this.querySelector("#upsellLoader").classList.add("hidden");
        } else {
          this.items = this.closest("new-cart-drawer").querySelectorAll(
            "[data-main-cart-item]"
          );
          this.lastItem =
            this.items[0].dataset.mainCartItem;
          this.url = this.updateURL.replace("[REPLACE_WITH_ID]", this.lastItem);
          console.log(this.lastItem);
        }

        try {
          fetch(this.url)
            .then((response) => response.text())
            .then((text) => {
              const parser = new DOMParser();
              const html = parser.parseFromString(text, "text/html");
              this.el.innerHTML = html.querySelector("#cartUpsell").innerHTML;
            })
            .finally(() => {
              this.querySelector("#upsellLoader").classList.add("hidden");
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  );
}
